module.exports = __webpack_public_path__ + "static/img/blog-list-image-1.77802d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-list-image-1.jpg
// module id = PJk5
// module chunks = 0